import React from "react";
import { publicImageProps } from "../../../../../../../../services/config";
import DefaultImage from "../../../../../../../../components/common/default-image/DefaultImage";

function QuickProductsTable({ products, deleteProduct }) {
  const getVariant = (item) => {
    if (!item?.product?.option) return null;

    return item.product.option.variations.find(
      (v) => v.sku === item.productVarSku
    );
  };

  const getInventoryInfo = (item) => {
    const variant = getVariant(item);

    if (variant) {
      return {
        stock: variant.stock,
        status: variant.inventoryStatus,
        value: variant.value,
      };
    }

    return {
      stock: item.product?.stock,
      status: item.product?.inventoryStatus,
      value: null,
    };
  };

  return (
    <div className="relative overflow-x-auto sm:rounded-lg mt-4">
      {products.length ? (
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th className="px-6 py-3">تصویر</th>
              <th className="px-6 py-3">نام کالا</th>
              <th className="px-6 py-3">موجودی</th>
              <th className="px-6 py-3">وضعیت موجودی</th>
              <th className="px-6 py-3">تعداد</th>
              <th className="px-6 py-3">عملیات</th>
            </tr>
          </thead>

          <tbody>
            {products.map((item, index) => {
              const inventory = getInventoryInfo(item);
              const isAvailable = inventory.status === "available";

              return (
                <tr
                  key={index}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td className="px-6 py-4">
                    <div className="w-8 h-8 rounded-md overflow-hidden">
                      {item?.product?.mainImage ? (
                        <img
                          {...publicImageProps(item.product.mainImage)}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <DefaultImage imgClass="!w-full !h-full" />
                      )}
                    </div>
                  </td>

                  <td className="px-6 py-4">
                    {item.product?.name}
                    {inventory.value && ` - ${inventory.value}`}
                  </td>

                  <td className="px-6 py-4">{inventory.stock}</td>

                  <td
                    className={`px-6 py-4 font-medium ${
                      isAvailable ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    {isAvailable ? "موجود" : "ناموجود"}
                  </td>

                  <td className="px-6 py-4">{item.count}</td>

                  <td className="px-6 py-4">
                    <span
                      onClick={() => deleteProduct(index)}
                      className="cursor-pointer text-red-500 hover:text-red-700"
                    >
                      حذف
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="py-10 shadow flex items-center justify-center text-gray-500 rounded-xl">
          <p>شما هنوز هیچ محصولی انتخاب نکرده اید</p>
        </div>
      )}
    </div>
  );
}

export default QuickProductsTable;